import React from 'react';
import './WhyFacelead.css';

const WhyFacelead = () => {
  return (
    <div className="chunk-container"> 
    <div className="chunk-content">
        <div className="whyfacelead-text"> 
        <h1 className="normal-title">Why FaceLead?</h1>
          <p><span className="dot-whyfacelead"></span>Take full control of your computer: do every task typically done with a mouse and keyboard.</p>
          <p><span className="dot-whyfacelead"></span>Limitless customization to suit your specific needs: Choose your own gestures and create your own modes.</p>
          <p><span className="dot-whyfacelead"></span>You just need a computer with a webcam, No external hardware is required.</p>
          <p><span className="dot-whyfacelead"></span>Download for free.</p>
        </div>
    </div>
    </div>
  );
};

export default WhyFacelead;